import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button, Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
  savemsg,
  saveWarningMsg,
  serverMsg
} from "../../config/messageconstant";
import { getSalesExecutiveByUserType } from "../../Slice/salesExecutive.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadExcel, downloadF } from "../PDF/PDFDownload";

import BeatAssignImportPopUp from "./BeatAssignImportPopUp";
const ExcelJS = require("exceljs");

class BeatAssignImportExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs(),
      toDate: dayjs(),
      salesTeam: "",
      searchValue: "",
      importPopUpFlag: false,
      validatedProductList: [],
      hasErrorRow: false,
    };

    this.tableStyles = {
      tabContainer: {
        display: "flex",
        marginBottom: "16px",
        borderBottom: "1px solid #E5F1F9",
      },
      tableWrapper: {
        maxHeight: "570px",
        overflowY: "auto",
        overflowX: "auto", // Enable horizontal scrolling
        width: "100%",
        border: "1px solid rgb(182, 186, 188)",
        borderRadius: "8px",
      },
      table: {
        minWidth: "2800px", // Minimum width to ensure all columns are visible
        width: "max-content", // Allow table to grow based on content
        borderCollapse: "collapse",
        tableLayout: "auto", // Auto layout for flexible column sizing
      },
      stickyHeader: {
        position: "sticky",
        top: 0,
        backgroundColor: "rgb(233, 240, 243)",
        zIndex: 10,
      },
      tab: {
        padding: "8px 16px",
        cursor: "pointer",
        color: "#333",
        fontSize: "14px",
        fontWeight: "500",
        transition: "color 0.2s ease-in-out",
      },
      activeTab: {
        color: "#1C4E80",
        borderBottom: "2px solid #1C4E80",
      },
      noData: {
        padding: "16px",
        textAlign: "center",
        fontSize: "14px",
        color: "#666",
      },
      tableContainer: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "16px",
        maxWidth: "100%", // Allow full width usage
        margin: "0 auto",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      },
      searchContainer: {
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        maxWidth: "300px",
      },
      headerRow: {
        backgroundColor: "rgb(233, 240, 243)",
        color: "#000",
        fontWeight: "bold",
        fontSize: "14px",
      },
      headerCell: {
        padding: "12px 8px", // Reduced horizontal padding for better space utilization
        textAlign: "center",
        borderBottom: "2px solid #E5F1F9",
        borderRight: "1px solid #E5F1F9", // Add right border for better column separation
        fontWeight: 600,
        whiteSpace: "nowrap", // Prevent text wrapping in headers
        position: "sticky",
        top: 0,
        backgroundColor: "rgb(233, 240, 243)",
      },
      dataRow: {
        backgroundColor: "#fff",
        transition: "background-color 0.2s ease-in-out",
      },
      dataRowHover: {
        backgroundColor: "#E5F1F9",
      },
      dataCell: {
        padding: "12px 8px", // Reduced horizontal padding
        fontSize: "13px",
        color: "#333",
        borderBottom: "1px solid #E5F1F9",
        borderRight: "1px solid #E5F1F9", // Add right border for better column separation
        whiteSpace: "nowrap", // Prevent text wrapping
        overflow: "hidden",
        textOverflow: "ellipsis", // Show ellipsis for long text
      },
      amountCell: {
        color: "#004969",
        fontWeight: "500",
        fontSize: "13px",
      },
      alternateRow: {
        backgroundColor: "#fff",
      },
      searchInput: {
        width: "100%",
        padding: "8px 12px",
        fontSize: "14px",
        border: "1px solid #E5F1F9",
        borderRadius: "6px",
        outline: "none",
        color: "#333",
        transition: "border-color 0.3s ease-in-out",
      },
      searchInputFocus: {
        borderColor: "#1C4E80",
        boxShadow: "0 0 5px rgba(28, 78, 128, 0.3)",
      },
    };
  }

  onClickOfExport = () => {
    const { showLoador, showNotification } = this.props;

    showLoador({ loador: true });
    downloadF({
      isGet: true,
      url: endpoint.exportData + "/get-beat-assign-export-excel",
      ext: "xls",
      openNewTab: false,
      isShowSalesPersonName: true,
      reportName: "Beat-Assign-Import-Export",
    }).then((response) => {
      showLoador({ loador: false });
      if (!response) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
    });
  };

  onClickOfImport = () => {
    this.setState({ importPopUpFlag: true });
  };

  onSearchBox = (e) => {
    this.setState({
      searchValue: e.target.value,
    });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;

      let employeeCode = currentRow?.employeeCode;

      let beatName = currentRow?.beatName;
      let dailyAllowance = currentRow?.dailyAllowance;
      let ratePerKm = currentRow?.ratePerKm;
      let beatType = currentRow?.beatType;
      let isSelfAssign = currentRow?.isSelfAssign;

      if (
        (employeeCode &&
          employeeCode
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["errorMessage"] &&
          currentRow["errorMessage"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (beatName &&
          beatName
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (dailyAllowance &&
          dailyAllowance
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (ratePerKm &&
          ratePerKm
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (beatType &&
          beatType
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (isSelfAssign &&
          isSelfAssign
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onSubmit = () => {
    const { showLoador, showNotification } = this.props;
    const { validatedProductList } = this.state;

    let dataToSendList =
      validatedProductList.length !== 0 ? validatedProductList : [];

    swal({
      title: "Are you sure?",
      text: saveWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        apiPost({
          url: endpoint.importData + "/validated-beat-assign-data",
          postBody: dataToSendList,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            if (data && data.data && data.data.statusCode == 500) {
              showNotification({
                msg: data.data.message,
                severity: "error",
              });
            } else {
              showNotification({
                msg: savemsg,
              });
              window.location.reload();
            }
          }
        });
      }
    });
  };

  importPopUpClose = () => {
    this.setState({ importPopUpFlag: false });
  };

  dataMethod = (dataObj) => {
    const hasErrorRow = dataObj.some((item) => item.flag == 1);

    this.setState({ validatedProductList: dataObj, hasErrorRow });
  };

  filterExcel = () => {
    const { validatedProductList } = this.state;

    if (validatedProductList.length === 0) {
      this.props.showNotification({
        msg: "No data available for export",
        severity: "error",
      });
      return;
    }

    const filteredData = this.getFilteredTableData(validatedProductList);

    if (!filteredData || filteredData.length === 0) {
      this.props.showNotification({
        msg: "No data available for export",
        severity: "error",
      });
      return;
    }

    // Prepare column headers & rows
    const excelHeaders = [
      "Employee Code",
      "Sales Person Name",
      "Designation",
      "Date",
      "Day",
      "Beat",
    ];

    const formattedRows = filteredData.map((row) => [
      row.employeeCode || "-",
      row.salesTeamName || "-",
      row.designation || "-",
      row.dmyDate || "-",
      row.dayName || "-",
      row.beatNames || "-",
    ]);

    // ---------------- Excel Generation Code ----------------
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");

    // Put headers directly in first row (skip title & extra rows)
    excelHeaders.forEach((header, index) => {
      const cell = worksheet.getCell(1, index + 1);
      cell.value = header;
      cell.font = { bold: true, size: 12 };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    // Add data rows
    formattedRows.forEach((rowData) => {
      worksheet.addRow(rowData);
    });

    // Auto column width
    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength < 10 ? 10 : maxLength + 2;
    });

    // Freeze header row
    worksheet.views = [{ state: "frozen", ySplit: 1 }];

    // Download file
    const fileName = "Product_Export" + " - " + new Date();
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = fileName + ".xls";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };

  render() {
    const {
      fromDate,
      toDate,
      salesTeam,
      importPopUpFlag,
      validatedProductList,
      hasErrorRow,
    } = this.state;

    return (
      <>
        <Paper
          sx={{
            borderRadius: 2,
            p: { xs: 2, sm: 4 },
            boxShadow: "0 6px 32px rgba(0,0,0,0.08)",
            // background: "linear-gradient(135deg,rgb(251, 251, 251) 0%,rgb(238, 247, 250) 100%)",
            maxWidth: "auto",
            margin: "auto",
          }}
          elevation={5}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <LandingScreenHeader
              screenTitle="Import Beat Assign To Sales Team"
              showSaveBtnMain={false}
              showAddButton={false}
              showBackButton={false}
            />

            <div style={{ display: "flex", gap: 15 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="medium"
                startIcon={<CloudDownloadIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  transition: "all 0.2s",
                  minWidth: "120px",
                  height: "35px",
                  "&:hover": {
                    backgroundColor: "#f4f6fa",
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfExport}
              >
                Export
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<CloudUploadIcon sx={{ color: "#fff" }} />}
                sx={{
                  color: "#fff",
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  transition: "all 0.2s",
                  minWidth: "150px",
                  height: "35px",
                  "&:hover": {
                    backgroundColor: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfImport}
              >
                Import
              </Button>
            </div>
          </div>
          <br />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "5px",
            }}
          >
            {/* Search Box */}
            <input
              type="text"
              placeholder="Search..."
              value={this.state.searchValue}
              onChange={this.onSearchBox}
              style={{
                padding: "6px 10px",
                fontSize: "14px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                width: "230px",
              }}
            />
          </div>
          {/* Updated table JSX with improved scrolling and width management */}
          <div style={this.tableStyles.tableWrapper}>
            <table style={this.tableStyles.table}>
              <thead style={this.tableStyles.stickyHeader}>
                <tr style={this.tableStyles.headerRow}>
                  <th
                    style={{ ...this.tableStyles.headerCell, minWidth: "60px" }}
                  >
                    Sr.No
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "120px",
                      textAlign: "Center",
                    }}
                  >
                    Employee Code
                  </th>

                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "100px",
                      textAlign: "left",
                    }}
                  >
                    Beat Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "150px",
                      textAlign: "right",
                    }}
                  >
                    Daily Allowance
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "140px",
                      textAlign: "right",
                    }}
                  >
                    Rate Per Km
                  </th>

                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "140px",
                      textAlign: "center",
                    }}
                  >
                    Beat Sub Type
                  </th>

                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "80px",
                      textAlign: "center",
                    }}
                  >
                    Is Self Assign
                  </th>

                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      minWidth: "200px",
                      textAlign: "left",
                    }}
                  >
                    Error Message
                  </th>
                </tr>
              </thead>
              <tbody>
                {validatedProductList.length !== 0 &&
                  this.getFilteredTableData(validatedProductList).map(
                    (row, index) => (
                      <tr
                        key={index + 1}
                        style={{
                          ...this.tableStyles.dataRow,
                          ...this.tableStyles.alternateRow,
                          ...(index % 2 === 0
                            ? this.tableStyles.alternateRow
                            : {}),
                          ...(row.flag == 1 && { backgroundColor: "#ed8e98" }),
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor =
                            this.tableStyles.dataRowHover.backgroundColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor =
                            row.flag == 1
                              ? "#ed8e98"
                              : index % 2 === 0
                              ? this.tableStyles.alternateRow.backgroundColor
                              : this.tableStyles.dataRow.backgroundColor;
                        }}
                      >
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "60px",
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "120px",
                            textAlign: "center",
                          }}
                        >
                          {row?.employeeCode || "-"}
                        </td>

                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "100px",
                            textAlign: "left",
                          }}
                        >
                          {row?.beatName || "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "150px",
                            textAlign: "right",
                          }}
                        >
                          {row?.dailyAllowance || "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "140px",
                            textAlign: "right",
                          }}
                        >
                          {row?.ratePerKm || "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "180px",
                            textAlign: "center",
                          }}
                        >
                          {row?.beatType || "-"}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            minWidth: "80px",
                            textAlign: "center",
                          }}
                        >
                          {row?.isSelfAssign || "-"}
                        </td>

                        {row.flag == 1 ? (
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              minWidth: "200px",
                              textAlign: "left",
                            }}
                          >
                            {row.errorMessage !== null ? row.errorMessage : "-"}
                          </td>
                        ) : (
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              minWidth: "200px",
                              textAlign: "center",
                            }}
                          >
                            {"-"}
                          </td>
                        )}
                      </tr>
                    )
                  )}

                {validatedProductList.length === 0 && (
                  <tr>
                    <td colSpan="18" style={this.tableStyles.noData}>
                      No Data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {validatedProductList.length !== 0 && !hasErrorRow && (
            <>
              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                rowSpacing={2}
                columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                container
                justifyContent="right"
                sx={{ marginTop: 3 }}
              >
                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name="Submit"
                  onClick={this.onSubmit}
                />
              </Grid>
            </>
          )}

          {importPopUpFlag && (
            <BeatAssignImportPopUp
              open={importPopUpFlag}
              handleCloses={this.importPopUpClose}
              dataMethod={this.dataMethod}
            />
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesPersonList: state.salesExecutive,
});

const mapDispatchToProps = {
  showLoador,
  showNotification,
  downloadExcel,
  getSalesExecutiveByUserType,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(BeatAssignImportExport);
